<template>
	<b-btn
		:variant="variant"
		:size="size"
		:block="computedBlock"
		>
		<slot></slot>
	</b-btn>
</template>

<script>
	export default {
		props: {
			variant: {
				type: String,
				default: "primary"
			},
			size: {
				type: String,
				default: "sm"
			},
			block: {
				type: [String, Boolean],
				default: false
			}
		},
		computed: {
			computedBlock() {
				if(this.block === "true") return true
				else return false
			}
		}
	}
</script>

<style>
	
</style>